import { Mic } from "lucide-react";

import { PageHeader } from "@/shared/ui/PageHeader";
import VoiceProfilePage from "./VoiceProfilePage";

/**
 * 声音库独立页(2026-08-10):`/ai-digital-human/voices` 的落点。
 *
 * ★为什么要有这页:07-27 T5 把旧「我的资产」收编进人物库时,顺手把 `/voices` 也 302 到了
 *   `/characters` —— 但 08-07 IA 重构的卡墙「声纹克隆」卡 route 恰恰指 `/voices`
 *   (设计稿 §3.4 按「已是独立页」设计,当时已经不成立)。结果点「声纹克隆」落到人物库墙,
 *   被推去老板 IP **图片**采集流;声音库(克隆卡 + 公共声音试听墙 + 「用 TA 出片」分流)
 *   埋在 `/characters/:id → 真人原料 → 我的声纹` 三层深,没建过人物的用户根本走不到。
 *
 * ★声纹不依赖「先有人物」—— 独立可达是对的。现行口径(0915 老板批示一):授权入库后全公司共用、
 *   录音克隆须本人、跨公司隔离、删除仅本人或管理员;
 *   人物详情的内嵌形态(DhRealAssetsPanel)原样保留,这里只是同一块内容多一个直达外壳。
 */
export default function VoiceLibraryPage() {
  return (
    <div className="w-full space-y-6">
      <PageHeader
        backTo="/ai-digital-human"
        icon={Mic}
        title="声音库"
        subtitle="克隆自己的专属音色(即录即证 / 上传样本),或从公共声音里试听挑一款 —— 每张音色卡可直接「用 TA 出片」。"
      />
      <VoiceProfilePage />
    </div>
  );
}
